import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "about-section",
  id: "about"
}
const _hoisted_2 = { class: "section-shell about-grid" }
const _hoisted_3 = { class: "about-visual reveal" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "about-copy reveal" }
const _hoisted_6 = { class: "about-points" }
const _hoisted_7 = {
  href: "#contact",
  class: "text-link"
}

import { ArrowUpRight, CheckCircle2 } from "lucide-vue-next";
import "@/assets/styles/about.css";
import aboutImg from "@/assets/images/about-garden.png";

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(aboutImg),
          alt: "Professionell gestaltete Außenanlage"
        }, null, 8, _hoisted_4),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "image-caption" }, [
          _createElementVNode("span", null, "Planung"),
          _createElementVNode("span", null, "Ausführung"),
          _createElementVNode("span", null, "Pflege")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "eyebrow" }, "Freiraum beginnt mit Weitblick", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("h2", null, [
          _createTextVNode("Außenanlagen sind mehr als "),
          _createElementVNode("em", null, "schönes Grün.")
        ], -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "lead" }, "Sie sind Empfang, Aufenthaltsort und Visitenkarte. Deshalb verbinden wir Gestaltung mit Handwerk und denken jedes Projekt vom Alltag seiner Nutzer her.", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createVNode(_unref(CheckCircle2)),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Ein Ansprechpartner"),
              _createElementVNode("small", null, "Von der Idee bis zur Abnahme")
            ], -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(CheckCircle2)),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Planbar & transparent"),
              _createElementVNode("small", null, "Klare Abläufe, saubere Kommunikation")
            ], -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(CheckCircle2)),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Langfristig gedacht"),
              _createElementVNode("small", null, "Robuste Lösungen und passende Pflege")
            ], -1))
          ])
        ]),
        _createElementVNode("a", _hoisted_7, [
          _cache[4] || (_cache[4] = _createTextVNode("Lernen Sie uns kennen ", -1)),
          _createVNode(_unref(ArrowUpRight), { size: 18 })
        ])
      ])
    ])
  ]))
}
}

})